
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexAxFjNS68UggTpTtHZ9BqtIRz9RZHtRErunUUruMe14EMeta } from "/home/infinity/tut/tutassur_website/pages/blog/index.vue?macro=true";
import { default as _91slug_93oS4o7X_45GtVKHo4l_CzZau3ZXu29KmXVyrRm5Yi4KOFsMeta } from "/home/infinity/tut/tutassur_website/pages/blog/[slug].vue?macro=true";
import { default as indexhPOVWmaada_KWAZFilxixvvoN2P1lzJuzAej0NIQ8OQMeta } from "/home/infinity/tut/tutassur_website/pages/index/index.vue?macro=true";
import { default as index_P2WkK68MHRFsY_4__HtYAEPnU4B6vDraIDLtlDPtBwMeta } from "/home/infinity/tut/tutassur_website/pages/credit/index.vue?macro=true";
import { default as indexMfpPtcwh1BJRsJmCuDWuwIsH7eWh0iGMH9d9_S4EYhsMeta } from "/home/infinity/tut/tutassur_website/pages/annuaire/index.vue?macro=true";
import { default as index38hJ2r6x_459GE4KGT00C895LyzX5c_45_45nQRSt48vhCTl8Meta } from "/home/infinity/tut/tutassur_website/pages/contactez-nous/index.vue?macro=true";
import { default as indexdufcwf0kj_45sPwrj9q60s4AG6ki4_Wc6434nQ7aloBwYMeta } from "/home/infinity/tut/tutassur_website/pages/qui-sommes-nous/index.vue?macro=true";
import { default as mentions_45legalesIoJTSD8hh75A2nX_45aqnAQU7jm1b7Sw1MMkgrHyWIIDUMeta } from "/home/infinity/tut/tutassur_website/pages/legal/mentions-legales.vue?macro=true";
import { default as indexMGLJkQUb7OsFbI_tKdGmqCml6qrb6TceRnbsexCfjLIMeta } from "/home/infinity/tut/tutassur_website/pages/devenir-partenaire/index.vue?macro=true";
import { default as contactez_45nousxH6fV5qmIz4LB7YfOf3wwgKoNsqpOQBxOb7_45oaQBbooMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/contactez-nous.vue?macro=true";
import { default as politique_45de_45cookieslx6CLGqBp6WYljdunZwhB0XGIhOEte6WoO0VAflIsjcMeta } from "/home/infinity/tut/tutassur_website/pages/legal/politique-de-cookies.vue?macro=true";
import { default as declarer_45un_45sinistreYuNIXsMnxaN_45_QO_45rG_45WBsK0dsK4m8KIYZfm8DfJKV8Meta } from "/home/infinity/tut/tutassur_website/pages/sinistre/declarer-un-sinistre.vue?macro=true";
import { default as indexaZGh_oc36keAxbGFhVUJJbyGD5yyI36cQMc0yoRxHVAMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/particuliers/auto/index.vue?macro=true";
import { default as politique_45de_45confidentialiterHXkzC46XUXDcLz4MijtKf8OwD5KljHIp_45xk66RSfrgMeta } from "/home/infinity/tut/tutassur_website/pages/legal/politique-de-confidentialite.vue?macro=true";
import { default as indexpMMmUviKofhNdunZggRdkdzOBmxlHb4MagIgGwNbSosMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/particuliers/sante/index.vue?macro=true";
import { default as indexO38PTDvYEhcKzuM3FTMjomBsq5xOeqHor_fqpdoxe3MMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/particuliers/bateau/index.vue?macro=true";
import { default as indexfntsyyTjS3E1_45iFQTPnnANi15jO3MmwM0pVURXSb5jUMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/particuliers/animaux/index.vue?macro=true";
import { default as indexi9vr29q_UhdRB_aGxLAwcyCDfNzeMI_454omgfRjulgQIMeta } from "/home/infinity/tut/tutassur_website/pages/demande-de-resiliation-de-contrat/index.vue?macro=true";
import { default as indexKeJAga7_45vmV1je5eIwCgVfeeHJDT7aKzkK2fI4QM6ZcMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/particuliers/emprunteur/index.vue?macro=true";
import { default as indexSYp7r96XyMaQAxjbVpUgLahgRZKAawOh35nG3zoE62oMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/particuliers/habitation/index.vue?macro=true";
import { default as index889sk6qOCRNxIfcbmruj6fu_45dN4bG5hehhGBEcq9yV0Meta } from "/home/infinity/tut/tutassur_website/pages/assurances/particuliers/multimedia/index.vue?macro=true";
import { default as indexygcd9HtkyvuFseP7ETG0X7nXWVveil4bzjBof1rXJ5UMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/particuliers/prevoyance/index.vue?macro=true";
import { default as indexUkr__tjh0u2zCp4lLJNmU_45WaKInZLoAzTHRWSqrl_DkMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/rc-pro/index.vue?macro=true";
import { default as indexb0bCZWFkKSq3Ab7LEfJNbLy0k_hXgbtzjmNaB_45s43ZYMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/particuliers/moto-scooter/index.vue?macro=true";
import { default as indexd9OpvyTkXxD_z1xn172MqGdNvpvVbciVmcdzmAIS8s8Meta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/auto-pro/index.vue?macro=true";
import { default as indexF5bDlly68EVBVnYKZ_xsyW9AnJF0yfPiLxR7JKbrSMIMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/vtc-taxi/index.vue?macro=true";
import { default as index60wtdDqe5Y7qfh9nZ1FSFg2mLhwlYrVKaB_uLzcppRwMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/particuliers/internationale/index.vue?macro=true";
import { default as index105cb139r2wlF10ZpxJsAiZ4MMXo59kRNOaNnVVmpA0Meta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/flotte-auto/index.vue?macro=true";
import { default as indexANklvV8is_wt2gUoYah_45fx7GiGr39g_45jcj6iBAZxPvwMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/pro-de-lauto/index.vue?macro=true";
import { default as indexS6IQ7TwhwUl8k41vDS9FExecRauYOdrHBKhA_FW7Ag4Meta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/rc-decennale/index.vue?macro=true";
import { default as garageQGpUsVHjwocwzYOUIfO5EQ6SMTjWauAGijlZMq0tgEkMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/pro-de-lauto/garage.vue?macro=true";
import { default as indexkD5Jd5e65o_fnusKN24X1jLQtOTLV9kV_45StOOfuP7MUMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/particuliers/comparateurs/sante/index.vue?macro=true";
import { default as index951GkoSZPwRnGzzajpQVTXpyk_eC7xTtLOEVX_45dER_4Meta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/prevoyance-pro/index.vue?macro=true";
import { default as indexbHMzGvWFbCBBmFapO1xOZ108WZTR6hZpSbbc0rd6K5AMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/dommage-ouvrage/index.vue?macro=true";
import { default as index6cSd4wxhDnjSsP8DXzShE9xMlF5MdMMYYee278HYaeYMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/particuliers/protection-juridique/index.vue?macro=true";
import { default as indexnx7VPz9yz6PIeVImhfM3JauXTzBpyMJGi9w_oRE6AJYMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/particuliers/deux-roues-electrique/index.vue?macro=true";
import { default as carrosserieVaKm_UmBc2lq5jaIVx4INZfEznMpGOO_45eZU2tu7YYx8Meta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/pro-de-lauto/carrosserie.vue?macro=true";
import { default as indexGfns8KJHj8QlXgq7xYzhcPmSDjhGgAgwjqiWtFaPy_45sMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/particuliers/comparateurs/emprunteur/index.vue?macro=true";
import { default as indexwrXlvzLSVo5L_8a_C0aBBObxaLWTRiqWntj0EoYU51gMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/particuliers/comparateurs/prevoyance/index.vue?macro=true";
import { default as negociants_45autouDPU4mB2wd3BlUxKnBxXQlKpYz0WlRBV_45J7Un0qhhFQMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/pro-de-lauto/negociants-auto.vue?macro=true";
import { default as indexft77H4QQH3SD_mHty93JJJkdSNlsskl5xEa4CvFJIwQMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/protection-juridique-pro/index.vue?macro=true";
import { default as indexZkmu6iUF_O4qbB7uNEVhjDHyuamURJb_z_KOBclqyPcMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/marchandises-transportees/index.vue?macro=true";
import { default as indexegii4L4IkFYX5cDa_45qc4Hewi6sC3T_b0LsNkWzJzbicMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/mutuelle-sante-collective/index.vue?macro=true";
import { default as indexwu5Y7btgJi37xHq21K6kZKc_yftP03oOn10cWrPHiXoMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/multirisque-professionnelle/index.vue?macro=true";
import { default as assurance_45controle_45techniqueeCBdvkPkHFe1lJjs2PmEue8Mo8da7zDVrxtfo0BGsVsMeta } from "/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/pro-de-lauto/assurance-controle-technique.vue?macro=true";
export default [
  {
    name: "blog",
    path: "/blog",
    component: () => import("/home/infinity/tut/tutassur_website/pages/blog/index.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/home/infinity/tut/tutassur_website/pages/blog/[slug].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/infinity/tut/tutassur_website/pages/index/index.vue")
  },
  {
    name: "credit",
    path: "/credit",
    component: () => import("/home/infinity/tut/tutassur_website/pages/credit/index.vue")
  },
  {
    name: "annuaire",
    path: "/annuaire",
    component: () => import("/home/infinity/tut/tutassur_website/pages/annuaire/index.vue")
  },
  {
    name: "contactez-nous",
    path: "/contactez-nous",
    component: () => import("/home/infinity/tut/tutassur_website/pages/contactez-nous/index.vue")
  },
  {
    name: "qui-sommes-nous",
    path: "/qui-sommes-nous",
    component: () => import("/home/infinity/tut/tutassur_website/pages/qui-sommes-nous/index.vue")
  },
  {
    name: "legal-mentions-legales",
    path: "/legal/mentions-legales",
    component: () => import("/home/infinity/tut/tutassur_website/pages/legal/mentions-legales.vue")
  },
  {
    name: "devenir-partenaire",
    path: "/devenir-partenaire",
    component: () => import("/home/infinity/tut/tutassur_website/pages/devenir-partenaire/index.vue")
  },
  {
    name: "assurances-contactez-nous",
    path: "/assurances/contactez-nous",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/contactez-nous.vue")
  },
  {
    name: "legal-politique-de-cookies",
    path: "/legal/politique-de-cookies",
    component: () => import("/home/infinity/tut/tutassur_website/pages/legal/politique-de-cookies.vue")
  },
  {
    name: "sinistre-declarer-un-sinistre",
    path: "/sinistre/declarer-un-sinistre",
    component: () => import("/home/infinity/tut/tutassur_website/pages/sinistre/declarer-un-sinistre.vue")
  },
  {
    name: "assurances-particuliers-auto",
    path: "/assurances/particuliers/auto",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/particuliers/auto/index.vue")
  },
  {
    name: "legal-politique-de-confidentialite",
    path: "/legal/politique-de-confidentialite",
    component: () => import("/home/infinity/tut/tutassur_website/pages/legal/politique-de-confidentialite.vue")
  },
  {
    name: "assurances-particuliers-sante",
    path: "/assurances/particuliers/sante",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/particuliers/sante/index.vue")
  },
  {
    name: "assurances-particuliers-bateau",
    path: "/assurances/particuliers/bateau",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/particuliers/bateau/index.vue")
  },
  {
    name: "assurances-particuliers-animaux",
    path: "/assurances/particuliers/animaux",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/particuliers/animaux/index.vue")
  },
  {
    name: "demande-de-resiliation-de-contrat",
    path: "/demande-de-resiliation-de-contrat",
    component: () => import("/home/infinity/tut/tutassur_website/pages/demande-de-resiliation-de-contrat/index.vue")
  },
  {
    name: "assurances-particuliers-emprunteur",
    path: "/assurances/particuliers/emprunteur",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/particuliers/emprunteur/index.vue")
  },
  {
    name: "assurances-particuliers-habitation",
    path: "/assurances/particuliers/habitation",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/particuliers/habitation/index.vue")
  },
  {
    name: "assurances-particuliers-multimedia",
    path: "/assurances/particuliers/multimedia",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/particuliers/multimedia/index.vue")
  },
  {
    name: "assurances-particuliers-prevoyance",
    path: "/assurances/particuliers/prevoyance",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/particuliers/prevoyance/index.vue")
  },
  {
    name: "assurances-professionnelles-rc-pro",
    path: "/assurances/professionnelles/rc-pro",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/rc-pro/index.vue")
  },
  {
    name: "assurances-particuliers-moto-scooter",
    path: "/assurances/particuliers/moto-scooter",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/particuliers/moto-scooter/index.vue")
  },
  {
    name: "assurances-professionnelles-auto-pro",
    path: "/assurances/professionnelles/auto-pro",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/auto-pro/index.vue")
  },
  {
    name: "assurances-professionnelles-vtc-taxi",
    path: "/assurances/professionnelles/vtc-taxi",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/vtc-taxi/index.vue")
  },
  {
    name: "assurances-particuliers-internationale",
    path: "/assurances/particuliers/internationale",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/particuliers/internationale/index.vue")
  },
  {
    name: "assurances-professionnelles-flotte-auto",
    path: "/assurances/professionnelles/flotte-auto",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/flotte-auto/index.vue")
  },
  {
    name: "assurances-professionnelles-pro-de-lauto",
    path: "/assurances/professionnelles/pro-de-lauto",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/pro-de-lauto/index.vue")
  },
  {
    name: "assurances-professionnelles-rc-decennale",
    path: "/assurances/professionnelles/rc-decennale",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/rc-decennale/index.vue")
  },
  {
    name: "assurances-professionnelles-pro-de-lauto-garage",
    path: "/assurances/professionnelles/pro-de-lauto/garage",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/pro-de-lauto/garage.vue")
  },
  {
    name: "assurances-particuliers-comparateurs-sante",
    path: "/assurances/particuliers/comparateurs/sante",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/particuliers/comparateurs/sante/index.vue")
  },
  {
    name: "assurances-professionnelles-prevoyance-pro",
    path: "/assurances/professionnelles/prevoyance-pro",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/prevoyance-pro/index.vue")
  },
  {
    name: "assurances-professionnelles-dommage-ouvrage",
    path: "/assurances/professionnelles/dommage-ouvrage",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/dommage-ouvrage/index.vue")
  },
  {
    name: "assurances-particuliers-protection-juridique",
    path: "/assurances/particuliers/protection-juridique",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/particuliers/protection-juridique/index.vue")
  },
  {
    name: "assurances-particuliers-deux-roues-electrique",
    path: "/assurances/particuliers/deux-roues-electrique",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/particuliers/deux-roues-electrique/index.vue")
  },
  {
    name: "assurances-professionnelles-pro-de-lauto-carrosserie",
    path: "/assurances/professionnelles/pro-de-lauto/carrosserie",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/pro-de-lauto/carrosserie.vue")
  },
  {
    name: "assurances-particuliers-comparateurs-emprunteur",
    path: "/assurances/particuliers/comparateurs/emprunteur",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/particuliers/comparateurs/emprunteur/index.vue")
  },
  {
    name: "assurances-particuliers-comparateurs-prevoyance",
    path: "/assurances/particuliers/comparateurs/prevoyance",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/particuliers/comparateurs/prevoyance/index.vue")
  },
  {
    name: "assurances-professionnelles-pro-de-lauto-negociants-auto",
    path: "/assurances/professionnelles/pro-de-lauto/negociants-auto",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/pro-de-lauto/negociants-auto.vue")
  },
  {
    name: "assurances-professionnelles-protection-juridique-pro",
    path: "/assurances/professionnelles/protection-juridique-pro",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/protection-juridique-pro/index.vue")
  },
  {
    name: "assurances-professionnelles-marchandises-transportees",
    path: "/assurances/professionnelles/marchandises-transportees",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/marchandises-transportees/index.vue")
  },
  {
    name: "assurances-professionnelles-mutuelle-sante-collective",
    path: "/assurances/professionnelles/mutuelle-sante-collective",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/mutuelle-sante-collective/index.vue")
  },
  {
    name: "assurances-professionnelles-multirisque-professionnelle",
    path: "/assurances/professionnelles/multirisque-professionnelle",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/multirisque-professionnelle/index.vue")
  },
  {
    name: "assurances-professionnelles-pro-de-lauto-assurance-controle-technique",
    path: "/assurances/professionnelles/pro-de-lauto/assurance-controle-technique",
    component: () => import("/home/infinity/tut/tutassur_website/pages/assurances/professionnelles/pro-de-lauto/assurance-controle-technique.vue")
  }
]